import { memo } from 'react';

import { useRoomContext } from '@src/contexts';
import { OModal } from '@src/shared';

import SettingsContent from './SettingContent';
import useSettingsModal from './useSettingsModal';

import './settingsModal.scss';

const SettingsModal = () => {
  const { isRoomSettingsOpen, setIsRoomSettingsOpen } = useSettingsModal();
  const { isMobileDevice } = useRoomContext();

  return (
    <>
      {!isMobileDevice && (
        <OModal
          isOpen={isRoomSettingsOpen}
          classes={{
            container: 'settings-modal',
            closeIcon: 'close-icon',
          }}
          onClose={() => setIsRoomSettingsOpen(false)}
          hasBackdrop
        >
          <SettingsContent />
        </OModal>
      )}
    </>
  );
};
export default memo(SettingsModal);
